<template>
  <div
    class="progress-dashboard"
    :style="{ height: width + 'px', width: width + 'px' }"
  >
    <svg viewBox="0 0 100 100">
      <path
        class="progress-circle__track"
        :d="trackPath"
        :stroke="borderColor"
        :stroke-linecap="linecap"
        :stroke-width="relativeStrokeWidth"
        fill="none"
        :style="trailPathStyle"
      />
      <path
        class="progress-circle__path"
        :d="trackPath"
        :stroke="stroke"
        fill="none"
        :stroke-linecap="linecap"
        :stroke-width="formatValue ? relativeStrokeWidth * 1.5 : 0"
        :style="circlePathStyle"
      />
    </svg>
    <div class="progress-dashboard__inner" v-if="$slots.default">
      <slot />
    </div>
    <div
      class="progress__text"
      :style="{ fontSize: progressTextSize + 'px' }"
      v-else
    >
      <template>{{ content }}</template>
    </div>
  </div>
</template>

<script>
export default {
  name: 'progress-bar',
  props: {
    // 进度值0-1
    value: {
      type: Number,
      default: 0,
      required: true,
      validator: (val) => val >= 0 && val <= 1,
    },
    // 进度条类型
    // type: {
    //   type: String,
    //   default: 'dashboard',
    //   validator: (val) => ['dashboard'].indexOf(val) > -1,
    // },
    // 圆环大小
    size: {
      type: Number,
      default: 70,
    },
    // 圆环宽度
    width: {
      type: Number,
    },
    // 圆环高亮颜色
    color: {
      type: [String, Array, Function],
      default: '#2F86F6',
    },
    // 圆环颜色
    borderColor: {
      type: String,
      default: 'rgba(0, 0, 0, .1)',
    },
    // 圆环内部填充
    fill: {
      type: String,
      default: 'transparent',
    },
    // 圆环两端形状
    linecap: {
      type: String,
      default: 'round', // butt | round
    },
    // 圆环旋转
    rotate: {
      type: Number,
      default: 0,
    },
    // 进度变化是否使用动效
    transition: {
      type: Boolean,
      default: false,
    },
    // 进度条的宽度，单位 px
    strokeWidth: {
      type: Number,
      default: 6,
    },
    // 进度变化动效时长
    duration: {
      type: Number,
      default: 1000,
    },
    // 是否显示进度条文字内容
    showText: {
      type: Boolean,
      default: true,
    },
    format: Function,
    // 圆圈的比例
    rateRadius: {
      type: Number,
      default: 0.5,
    },
  },
  data() {
    return {
      formatValue: 0,
      isMounted: false,
    }
  },
  computed: {
    relativeStrokeWidth() {
      return ((this.strokeWidth / this.width) * 100).toFixed(1)
    },
    radius() {
      return parseInt(49 - parseFloat(this.relativeStrokeWidth) / 2, 10)
    },
    trackPath() {
      const radius = this.radius
      return `
          M 50 50
          m 0 ${radius}
          a ${radius} ${radius} 0 1 1 0 -${radius * 2}
          a ${radius} ${radius} 0 1 1 0 ${radius * 2}
          `
    },
    perimeter() {
      return 2 * Math.PI * this.radius
    },
    rate() {
      return this.rateRadius
    },
    strokeDashoffset() {
      const offset = (-1 * this.perimeter * (1 - this.rate)) / 2
      return `${offset}px`
    },
    trailPathStyle() {
      return {
        strokeDasharray: `${this.perimeter * this.rate}px, ${this.perimeter}px`,
        strokeDashoffset: this.strokeDashoffset,
      }
    },
    circlePathStyle() {
      console.log(
        this.perimeter,
        `${this.perimeter * this.rate * this.value}px, ${this.perimeter}px`,
        this.strokeDashoffset
      )
      return {
        strokeDasharray: `${this.perimeter * this.rate * this.value}px, ${
          this.perimeter
        }px`,
        strokeDashoffset: this.strokeDashoffset,
        transition: 'stroke-dasharray 0.6s ease 0s, stroke 0.6s ease',
      }
    },
    stroke() {
      let ret
      if (this.color) {
        ret = this.$_getCurrentColor(this.value)
      } else {
        switch (this.status) {
          case 'success':
            ret = '#13ce66'
            break
          case 'exception':
            ret = '#ff4949'
            break
          case 'warning':
            ret = '#e6a23c'
            break
          default:
            ret = '#20a0ff'
        }
      }
      return ret
    },
    progressTextSize() {
      return this.width * 0.111111 + 2
    },
    content() {
      if (typeof this.format === 'function') {
        return this.format(parseInt(this.value * 100)) || ''
      } else {
        return `${parseInt(this.value * 100)}`
      }
    },
  },
  watch: {
    value: {
      handler(val, oldVal) {
        /* istanbul ignore if  */
        if (!this.isMounted || !this.transition) {
          this.formatValue = val
          return
        }
        // 暂时不需要动画注释了,以后有需求再加
        // this.$_doAnimateDisplay(oldVal, val)
      },
      immediate: true,
    },
  },
  mounted() {
    this.isMounted = true
  },
  methods: {
    $_doAnimateDisplay(fromValue = 0, toValue = 0) {
      /* istanbul ignore next  */
      const step = (percent) => {
        this.formatValue = fromValue + (toValue - fromValue) * percent
      }
      const verify = (id) => id
      /* istanbul ignore next  */
      // Animate.start(step, verify, noop, this.duration)
    },
    $_getCurrentColor(percentage) {
      if (typeof this.color === 'function') {
        return this.color(percentage)
      } else if (typeof this.color === 'string') {
        return this.color
      } else {
        return this.$_getLevelColor(percentage)
      }
    },
    $_getLevelColor(percentage) {
      const colorArray = this.$_getColorArray().sort(
        (a, b) => a.percentage - b.percentage
      )
      for (let i = 0; i < colorArray.length; i++) {
        if (colorArray[i].percentage > percentage) {
          return colorArray[i].color
        }
      }
      return colorArray[colorArray.length - 1].color
    },
    $_getColorArray() {
      const color = this.color
      const span = 100 / color.length
      return color.map((seriesColor, index) => {
        if (typeof seriesColor === 'string') {
          return {
            color: seriesColor,
            progress: (index + 1) * span,
          }
        }
        return seriesColor
      })
    },
  },
}
</script>

<style lang="scss">
.progress-dashboard {
  position: relative;
  line-height: 1;
  display: inline-block;
  &__inner {
    width: 100%;
    text-align: center;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    line-height: 1;
  }
  .progress__text {
    position: absolute;
    top: 50%;
    left: 0;
    width: 92%;
    text-align: center;
    margin: 0;
    transform: translate(0, -50%);
    display: inline-block;
    vertical-align: middle;
    color: red;
    font-size: 10px;
    margin: 0 7px;
  }
}
</style>
